import { Conduit } from '@aligned-solutions/conduit';
import { authentication } from '../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}xml`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {
  /**
   * @returns {AxiosPromise}
   */
  getImages(xmlChannelProductId) {
    return conduit.get(`product/${xmlChannelProductId}/images`);
  },

  /**
   * @returns {AxiosPromise}
   */
  activateImage(xmlChannelProductId, identifier) {
    return conduit.put(
      `product/${xmlChannelProductId}/images/${identifier}/update-active-status`,
      { active: true },
    );
  },

  /**
   * @returns {AxiosPromise}
   */
  deactivateImage(xmlChannelProductId, identifier) {
    return conduit.put(
      `product/${xmlChannelProductId}/images/${identifier}/update-active-status`,
      { active: false },
    );
  },

  /**
   * @returns {AxiosPromise}
   */
  deleteImage(xmlChannelProductId, identifier) {
    return conduit.delete(
      `product/${xmlChannelProductId}/images/${identifier}`,
    );
  },
};



// WEBPACK FOOTER //
// ./src/services/xmlchannel-service.js